import { getExperiment } from "@recare/core/model/experiments";
import { Careprovider } from "@recare/core/types";
import { fromUnixTime, getUnixTime, isToday, isValid, subDays } from "date-fns";
import { useConnecterWithLoggedAccount } from "reduxentities/selectors/hooks";

export const useShowNewCapacity = () => {
  const account = useConnecterWithLoggedAccount();
  return getExperiment({
    experimentName: "receiver_capacity",
    experiments: account?.experiments,
  });
};

export const isOlderThanTwoWeeksAgo = (updatedAt: number) => {
  const twoWeeksAgo = getUnixTime(subDays(new Date(), 14));

  return twoWeeksAgo > updatedAt;
};

export const getSnoozedKey = (accountId: number) =>
  `${accountId}-snoozed-capacity`;

export const handleCloseNotification = ({
  accountId,
  onClose,
}: {
  accountId: number;
  onClose: () => void;
}) => {
  return () => {
    localStorage.setItem(
      getSnoozedKey(accountId),
      getUnixTime(new Date()).toString(),
    );
    onClose();
  };
};

export const shouldShowCapacityNotification = ({
  accountId,
  activateNewCapacity,
  careprovider,
}: {
  accountId: number;
  activateNewCapacity: boolean;
  careprovider: Careprovider;
}): boolean => {
  if (!activateNewCapacity) return false;

  const snoozeKey = getSnoozedKey(accountId);
  const snoozedTime = localStorage.getItem(snoozeKey);

  if (snoozedTime != null) {
    const parsedSnoozedTime = parseInt(snoozedTime);
    if (
      isValid(parsedSnoozedTime) &&
      isToday(fromUnixTime(parsedSnoozedTime))
    ) {
      return false;
    }
    localStorage.removeItem(snoozeKey);
  }

  return (
    !careprovider.profile?.capacity?.updated_at ||
    isOlderThanTwoWeeksAgo(careprovider.profile.capacity.updated_at)
  );
};
